import { useEffect, useState } from 'react'

// Handle initial load/open logic for dialog
export const useInitialOpenLoad = ({
  initialLoad = true,
  initialOpen = false
}: {
  initialLoad?: boolean
  initialOpen?: boolean
}) => {
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(initialLoad)
  const [isOpen, setIsOpen] = useState<boolean>(initialOpen)

  useEffect(() => {
    if (isInitialLoad) {
      setIsInitialLoad(false)
    } else {
      setIsOpen(false)
    }
  }, [])

  return {
    isInitialLoad,
    isOpen,
    setIsOpen
  }
}
